module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan01_stay-b8d0021061164678d04da13691394778.jpg";